module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Chapter 1")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('h2', {
    staticClass: "h2sub"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Basics of Music")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Whether you are new to the study of music or are adept at reading and playing music, you need to have a firm grasp of the basics and an appreciation of its rich compositional history to understand music theory. With that in mind, this chapter offers an overview of the basic musical terms and concepts upon which music theory is built, as well as a brief history of musical styles.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0